// @ts-nocheck
import React, { useCallback } from 'react';
import { alpha, Box, Divider, useTheme } from '@mui/material';

import {
  useTableState,
  useTableDispatch,
} from '../../context/TableSchemaBuilderContext';
import FontStyleGroup from './FontStyles/FontStyleGroup';
import AlignmentGroup from './FontStyles/AlignmentGroup';
import LockGroup from './Protection/LockGroup';
import ValueTypeGroup from './ValueType/ValueTypeGroup';
import CellDataTypeGroup from './CellDataType/CellDataTypeGroup';
import ConditionalFormattingButton from './ConditionalFormatting/ConditionalFormattingButton';
import UploadedFile from './UploadedFile/UploadedFile';

const Toolbar = () => {
  const { ui, schema, config } = useTableState();
  const dispatch = useTableDispatch();
  const { currentCell } = ui;
  const cellFormat = schema.cells[currentCell]?.format || {};
  const theme = useTheme();

  const handleFormatChange = useCallback(
    (formatProperty, value = null) => {
      const formatUpdates = {};

      switch (formatProperty) {
        case 'bold':
          formatUpdates.fontWeight =
            cellFormat.fontWeight === 'bold' ? 'normal' : 'bold';
          break;
        case 'italic':
          formatUpdates.fontStyle =
            cellFormat.fontStyle === 'italic' ? 'normal' : 'italic';
          break;
        case 'underline':
          formatUpdates.textDecoration =
            cellFormat.textDecoration === 'underline' ? 'none' : 'underline';
          break;
        case 'alignLeft':
          formatUpdates.textAlign = 'left';
          break;
        case 'alignCenter':
          formatUpdates.textAlign = 'center';
          break;
        case 'alignRight':
          formatUpdates.textAlign = 'right';
          break;
        case 'textColor':
          formatUpdates.color = value;
          break;
        case 'backgroundColor':
          formatUpdates.backgroundColor = value;
          break;
        case 'toggleLock':
          dispatch({
            type: 'TOGGLE_CELL_LOCK',
            payload: {
              cellId: currentCell,
            },
          });
          break;
        default:
          break;
      }

      dispatch({
        type: 'UPDATE_CELL_FORMAT',
        payload: {
          cellId: currentCell,
          format: formatUpdates,
        },
      });
    },
    [cellFormat, dispatch, currentCell]
  );

  const handlePreventFocusLoss = useCallback((e) => {
    e.preventDefault();
  }, []);

  return (
    <Box
      onMouseDown={handlePreventFocusLoss}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        padding: '4px 8px',
        borderBottom: `1px solid ${alpha(theme?.palette?.primary?.main, 0.1)}`,
      }}
    >
      {!config?.fromConstAttributeFeature && (
        <>
          <FontStyleGroup
            cellFormat={cellFormat}
            onFormatChange={handleFormatChange}
          />
          <Divider orientation="vertical" flexItem />
          <AlignmentGroup
            cellFormat={cellFormat}
            onFormatChange={handleFormatChange}
          />
          <Divider orientation="vertical" flexItem />
          <LockGroup
            cellFormat={cellFormat}
            onFormatChange={handleFormatChange}
          />
          <Divider orientation="vertical" flexItem />
          <ValueTypeGroup />
          <Divider orientation="vertical" flexItem />
          <CellDataTypeGroup />
          <Divider orientation="vertical" flexItem />
          <ConditionalFormattingButton />
          <Divider orientation="vertical" flexItem />
        </>
      )}
      {config?.fromConstAttributeFeature && (
        <>
          <UploadedFile />
        </>
      )}
    </Box>
  );
};

export default Toolbar;
